<mat-card style="box-shadow: none; padding: 0 !important;" [class.mat-elevation-z1]="'true'">
    <mat-card-header>
        <span mat-card-avatar>
            <mat-icon>inventory_2</mat-icon>
        </span>
        <mat-card-title>Confirm Goods Count</mat-card-title>
    </mat-card-header>
    <mat-dialog-content>
        <p class="dialog-message">
            Confirm the number of goods collected. If the actual count differs from the expected total a discrepancy report will be submitted automatically.
        </p>

        <div class="count-row">
            <mat-form-field appearance="outline" class="count-field">
                <mat-label>Expected total</mat-label>
                <input matInput type="number" [value]="data.expectedGoods ?? ''" readonly />
                <mat-hint>From tour record</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="count-field">
                <mat-label>Actual count</mat-label>
                <input matInput type="number" min="0" step="1" [(ngModel)]="actualCount" />
            </mat-form-field>
        </div>

        <mat-chip-list *ngIf="actualCount != null">
            <mat-chip [color]="hasDiscrepancy ? 'warn' : 'primary'" selected>
                <mat-icon style="margin-right: 4px; font-size: 16px; line-height: 1.4;">{{ hasDiscrepancy ? 'warning' : 'check_circle' }}</mat-icon>
                {{ hasDiscrepancy ? 'Discrepancy detected — report will be sent' : 'Counts match' }}
            </mat-chip>
        </mat-chip-list>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button type="button" mat-button (click)="cancel()">Cancel</button>
        <button mat-raised-button color="primary" (click)="confirm()" [disabled]="actualCount == null || actualCount < 0">
            Confirm &amp; Collect
        </button>
    </mat-dialog-actions>
</mat-card>
